import { reactive } from 'vue';

import Orientation from '../types';

// eslint-disable-next-line import/prefer-default-export
export const reportState = reactive({
  legendTitle: '',
  orientation: Orientation.LANDSCAPE,
});
